import { motion } from "framer-motion";
import { SectionHeading } from "@/components/Produzioni";
import { TEAM } from "@/data/content";
import { useLang, pick } from "@/i18n";

const EASE = [0.16, 1, 0.3, 1];

export default function Team() {
    const { lang, ui } = useLang();

    return (
        <section id="team" data-testid="team-section" className="relative border-t border-white/5 bg-ink px-5 py-24 sm:px-8 sm:py-32">
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    label={ui.team.label}
                    title={ui.team.title}
                    sub={ui.team.sub}
                    testid="team-heading"
                />

                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {TEAM.map((m, i) => (
                        <motion.article
                            key={m.nome}
                            data-testid={`team-card-${i}`}
                            initial={{ opacity: 0, y: 44 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.9, delay: i * 0.09, ease: EASE }}
                            className="group relative overflow-hidden rounded-2xl border border-white/10 bg-charcoal transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-[0_20px_60px_rgba(244,28,51,0.15)]"
                        >
                            <div className="relative aspect-[3/4] overflow-hidden">
                                <img
                                    src={m.img}
                                    alt={`Ritratto di ${m.nome}`}
                                    loading="lazy"
                                    className="h-full w-full object-cover object-center grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-transparent to-transparent" />
                            </div>
                            <div className="p-5">
                                <h3 className="font-display text-xl font-bold text-white">{m.nome}</h3>
                                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-brand">{pick(lang, m, "ruolo")}</p>
                            </div>
                            <div className="absolute inset-0 flex flex-col justify-end bg-ink/90 p-6 opacity-0 backdrop-blur-sm transition-opacity duration-500 group-hover:opacity-100">
                                <h3 className="font-display text-xl font-bold text-white">{m.nome}</h3>
                                <p className="mb-3 mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-brand">{pick(lang, m, "ruolo")}</p>
                                <p className="text-sm leading-relaxed text-slate-300">{pick(lang, m, "bio")}</p>
                                <div className="mt-4 flex flex-wrap gap-2">
                                    {pick(lang, m, "skills").map((s) => (
                                        <span key={s} className="rounded-full border border-white/15 px-3 py-1 text-[11px] text-slate-300">
                                            {s}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
